import { useState } from "react";
import { Columns, Content, Footer, Modal } from "react-bulma-components";
import { Link } from "react-router-dom";
import { Credits } from "./Modals";
import { FullScreenModalContent } from "./Utilities";

function HomePageFooter(props) {
  const [openCreditsModal, setOpenCreditsModal] = useState(false);
  return (
    <Footer>
      <Content className="has-text-centered">
        <Columns>
          <Columns.Column>
            <strong>College</strong>
            {/* <br></br>
            <a href="http://google.com">About</a>
            <br></br>
            <a href="http://google.com">Careers</a> */}
            <br></br>
            <a
              href="mailto:yungklein@gmail.com?subject=Care Enquiry"
              target="_blank"
              rel="noreferrer noopener"
            >
              Contact Us
            </a>
          </Columns.Column>
          <Columns.Column>
            <strong>Services</strong>
            {/* <br></br>
            <a href="http://google.com">Care</a> */}
            <br></br>
            <a
              href="https://www.youtube.com/watch?v=gi6FLS2LXvE"
              target="_blank"
              rel="noreferrer noopener"
            >
              Therapy
            </a>
            {/* <br></br>
            <a href="http://google.com">Education</a> */}
          </Columns.Column>
          <Columns.Column>
            <strong>External</strong>
            <br></br>
            <a
              href="https://www.theguardian.com/society/2021/jul/16/no-10-hammers-out-plan-to-fix-uk-social-care-system-with-tax-rise"
              target="_blank"
              rel="noreferrer noopener"
            >
              News
            </a>
            <br></br>
            <a
              href="https://www.youtube.com/watch?v=vx-Lzo9NxAQ"
              target="_blank"
              rel="noreferrer noopener"
            >
              Success Stories
            </a>
          </Columns.Column>
          <Columns.Column>
            <strong>Legal</strong>
            <br></br>
            <a
              href="https://www.theguardian.com/society/2020/mar/13/wider-review-of-care-system-is-essential"
              target="_blank"
              rel="noreferrer noopener"
            >
              Privacy Policy
            </a>
            <br></br>
            <a
              href="#"
              onClick={() => {
                return setOpenCreditsModal(true);
              }}
            >
              Terms & Conditions
            </a>
            <br></br>
            <Link to="/dad">Dad</Link>
          </Columns.Column>
        </Columns>
      </Content>
      <Modal
        show={openCreditsModal}
        onClose={() => {
          return setOpenCreditsModal(false);
        }}
      >
        <FullScreenModalContent>
          <Credits></Credits>
        </FullScreenModalContent>
      </Modal>
    </Footer>
  );
}

export default HomePageFooter;
